import { createSelector } from "reselect";

import { IntegrationTypes } from "constants/integrations";

import { selectBusinessRelationsByBusinessIdLookup } from "../businessRelations";
import { getActiveLivestockAgentDeployment } from "../deploymentActiveAgent";
import { selectIntegrationBusinessesByBusinessIdByTypeLookup } from "../integrationBusinesses";
import {
  selectInterestSettingsByDeploymentIdLookup,
  selectResolvedInterestSettingsByBusinessIdLookup,
} from "../interest";
import { getBusinesses, getBusinessLabels } from "../root";
import { selectBusinessTradingTermsByIdLookup } from "../tradingTerms";
import { selectVendorCommissionBandsByBusinessIdLookup } from "../vendorCommissions";
import { selectBranchByIdLookup } from "../branches";

export const selectBusinessesAggridDataById = createSelector(
  [
    getBusinesses,
    selectResolvedInterestSettingsByBusinessIdLookup,
    selectVendorCommissionBandsByBusinessIdLookup,
    getActiveLivestockAgentDeployment,
    selectBusinessRelationsByBusinessIdLookup,
    selectBusinessTradingTermsByIdLookup,
    selectInterestSettingsByDeploymentIdLookup,
    selectIntegrationBusinessesByBusinessIdByTypeLookup,
    selectBranchByIdLookup,
    getBusinessLabels,
  ],
  (
    businessByIdLookup,
    resolvedInterestSettingsByBusinessId,
    vendorCommissionsByBusinessId,
    activeLivestockAgentDeployment,
    businessRelationsByBusinessIdLookup,
    tradingTermsByBusinessIdLookup,
    interestSettingsByDeploymentIdLookup,
    integrationBusinessesByTypeByBusinessIdLookup,
    branchByIdLookup,
    businessLabelById,
  ) => {
    return Object.values(businessByIdLookup).reduce((acc, business) => {
      const vendorCommissionBands =
        vendorCommissionsByBusinessId[business.id] || [];

      const xeroIntegrationBusiness =
        integrationBusinessesByTypeByBusinessIdLookup[IntegrationTypes.Xero]?.[
          business.id
        ]?.[0] || null;

      const tradingTerms = tradingTermsByBusinessIdLookup[business.id] || [];
      const businessInterestSettings =
        resolvedInterestSettingsByBusinessId[business.id];
      const deploymentInterestSettings =
        interestSettingsByDeploymentIdLookup[
          activeLivestockAgentDeployment?.id
        ];
      const relationships = businessRelationsByBusinessIdLookup[business.id];
      const branch = branchByIdLookup[business.branchId] || {};
      acc[business.id] = {
        business: {
          ...business,
          // Filter hidden things.
          properties: business.properties.filter(
            businessProperty => businessProperty.isShown,
          ),
          buyerWays: business.buyerWays.filter(buyerWay => buyerWay.isShown),
          labels: (business.labelIds || [])
            .map(id => businessLabelById[id])
            .filter(Boolean),
        },
        deployment: activeLivestockAgentDeployment,
        tradingTerms,
        // If we aren't overriding the interest settings, use the deployment interest settings
        interestSettings: business.overrideInterestSettings
          ? businessInterestSettings
          : deploymentInterestSettings,
        vendorCommissionBands,
        relationships,
        xeroIntegrationBusiness,
        branch,
        id: business.id,
      };
      return acc;
    }, {});
  },
);

export const selectBusinessesAggridData = createSelector(
  [selectBusinessesAggridDataById],
  businessesAggridDataById => Object.values(businessesAggridDataById),
);
